<div class="fw-bold bg-white p-3 rounded-5 mb-5 shadow">

    <div class="d-flex justify-content-between">
        <div>
            <label for="information" class="labelInformation">
                Update Ticket {{ id }}
            </label>
        </div>
        <div class="col btn-back text-end">
            <a class="btn btn-secondary" [routerLink]="['/tickets']">Back</a>
        </div>
    </div>

    <div class="col">
        <label for="iccid">User<span class="required">*</span></label>
        <input type="text" class="form-control input-label" [disabled]="true" [value]="userName" />
    </div>

    <div class="col">
        <label for="iccid">Iccid<span class="required">*</span></label>
        <input type="text" class="form-control input-label" [disabled]="true" [value]="iccid" />
    </div>


    <div class="col">
        <label for="iccid">Error<span class="required">*</span></label>
        <input type="text" class="form-control input-label" [disabled]="true" [value]="errorMessage" />
    </div>


    <div class="col-12">
        <label for="iccid">Description<span class="required">*</span></label>
        <textarea class="form-control input-label" type="text" class="form-control input-label"
            [(ngModel)]="description" [disabled]="true"></textarea>
    </div>
    <div class="col-12">
        <label for="iccid">Comment<span class="required">*</span></label>
        <textarea class="form-control input-label" type="text" class="form-control input-label"
            [(ngModel)]="comment"></textarea>
    </div>

    <div class="col-12">
        <label for="iccid">Status<span class="required">*</span></label>
        <select class="form-select input-label" [(ngModel)]="statusId">
            <option *ngFor="let status of statuses" [value]="status">{{ status }}</option>
        </select>
    </div>


    <!-- Cuarta fila -->
    <div class="row mt-2">
        <div class="col text-end">
            <button class="btn btn-primary w-100 w-md-auto" (click)="updateTicket()">
                Update Ticket
            </button>
        </div>
    </div>

</div>